import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from '@atlas/ui';
import CheckboxLabel from 'common/Form/Fields/CheckboxField/CheckboxLabel';
import Field from 'common/Form/Field';

const CheckboxField = ({ field, onChange, onFocus = () => {}, onBlur = () => {} }) => {
  const { touched, value, autofocus, errors, active, label, placeholder, name, disabled } = field;
  const checked = Boolean(value);
  const changeHandler = useCallback(
    event => {
      onChange(event);
    },
    [onChange],
  );
  const error = touched && errors[0];

  return (
    <Field options={field}>
      <Checkbox
        name={name}
        disabled={disabled}
        error={error}
        placeholder={placeholder}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={changeHandler}
        autoFocus={autofocus}
        touched={touched}
        active={active}
        label={label}
        checked={checked}
      >
        <CheckboxLabel label={label} />
      </Checkbox>
    </Field>
  );
};

CheckboxField.propTypes = {
  field: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

export default CheckboxField;
